export const DEFAULT_PAGINATION = {
  page: 1,
  size: 10,
};

export enum PaginationItemsSize {
  SMALL = "SMALL",
  LARGE = "LARGE",
}
